module.exports = __webpack_public_path__ + "img/16.e9343df9.jpg";